import React from 'react';
import { connect } from "react-redux";
import { updateData, updateFilterData, updateEditData } from "../actions";
import ReactQuill from 'react-quill';
import ControlService from '../../helper/controlservice';


function bindAction(dispatch) {
    return {
        update: (key, value, storekey) => dispatch(updateData(key, value, storekey)),
        updateEdit: (key, value) => dispatch(updateEditData(key, value)),
        updateFilter: (key, value) => dispatch(updateFilterData(key, value))
    };
}
const mapStateToProps = state => ({
    data: state.formDataReducer,
    filterdata: state.formDataReducer.filterdata,
    editformdata: state.formDataReducer.editformdata,
    hasErrored: state.formDataReducer.hasErrored,
    isLoading: state.formDataReducer.isLoading,
    token: state.formLoginReducer.token,
});

class Editor extends React.PureComponent {
    state = {
        touched: false,
        value: ""
    }
    static getDerivedStateFromProps(nextProps) {
        const { control, formid, data } = nextProps;
        var _data = data[formid] && data[formid][control.key] ? data[formid][control.key] : ""
        return {
            value: _data
        }
    }
    componentDidMount() {
        this.setState({ touched: this.state.value ? true : false });

        ControlService().controlVaildationCheck(this.props);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.value != prevState.value) {
            ControlService().controlVaildationCheck(this.props);
        }
    }
    handleChange(control, formid, value) {
        if (value == "<p><br></p>") {
            value = "";
        }
        // this.props.update(control.key, value.trim(), formid)
        // this.setState({ value: value });
        this.props.update(control.key, value, formid)
        
        var validation = ControlService().validate(control, value);
        var formValidation = this.props.data[formid + "_validation"] ? this.props.data[formid + "_validation"] : {}
        if (validation && (!formValidation[control.key] || formValidation[control.key].status != "pass")) {
            this.props.update(control.key, { "status": "pass", "control": control, touched: false }, formid + "_validation")
        } else if (!validation && (!formValidation[control.key] || formValidation[control.key].status != "fail")) {
            this.props.update(control.key, { "status": "fail", "control": control, touched: false }, formid + "_validation")
        }
    }
    handleBlur = () => {
        // const { control, action, formid } = this.props;
        // this.props.update(control.key, this.state.value, formid)
        this.setState({
            touched: true,
        }, () => this.CallResponseApi());
    }
    CallResponseApi() {
        
        const { control, formid } = this.props;
        if (control.responseapiurl) {
            const data = this.props.data[this.props.formid];
            let url = "";

            let apiparam = {};
            var dataModel = {};
            url = control.responseapiurl;
            if (!control.rowquery) {
                control.responseapiparam.forEach(option => {
                    if (option.isdatamodel) {
                        apiparam[option.key] = data[option.value];
                    } else {
                        apiparam[option.key] = option.value;
                    }

                    var paramVal = ControlService().GetParamUrl(option.value)
                    if (apiparam[option.key] == option.value && paramVal) {
                        apiparam[option.key] = paramVal;
                    }
                })

            }
            else {
                var rowQuery = control.rowquery;
                control.responseapiparam.forEach(option => {
                    if (option.isdatamodel)
                        rowQuery = rowQuery.replace("{{" + option.key + "}}", data[option.value] ? data[option.value] : '');
                    else {
                        var paramVal = ControlService().GetParamUrl(option.value)
                        rowQuery = rowQuery.replace("{{" + option.key + "}}", paramVal ? paramVal : option.value);
                    }
                })
                rowQuery = rowQuery.replace(/\r\n/g, '');
                rowQuery = rowQuery.replace(/\t/g, '');
                dataModel = JSON.parse(rowQuery);
            }

            
            if (!control.method) {
                control.method = "post";
            }
            ControlService().ServiceRequest(url, apiparam, control, this.props.token, dataModel)
                .then((res) => {
                    
                    var _data = res && res.data ? res.data : {};
                    if (typeof _data == 'object' && Array.isArray(_data[control.responsebindingfield])) {
                        if (Array.isArray(data[control.modelmappingfield]) && data[control.modelmappingfield].length > 0) {
                            if (_data[control.responsebindingfield].length > 0) {
                                // this.data[control.modelmappingfield] = data[control.responsebindingfield];
                                this.props.update(control.modelmappingfield, _data[control.responsebindingfield], formid);
                            }
                        } else if (_data[control.responsebindingfield]) {
                            // this.data[control.modelmappingfield] = data[control.responsebindingfield];
                            this.props.update(control.modelmappingfield, _data[control.responsebindingfield], formid);
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }
    shouldMarkError(control, data) {
        const validate = ControlService().validate(control, data);

        const validation = this.props.data[this.props.formid + "_validation"] ? this.props.data[this.props.formid + "_validation"][control.key] : null;
        const isTouchedOutside = validation ? validation.touched : false;
        const shouldShow = this.state.touched || isTouchedOutside;
        return validate ? !validate : shouldShow;
    }
    render() {
        const { control, action, formid } = this.props;
        var { value } = this.state;
        const shouldMarkError = this.shouldMarkError(control, value);
        if (action == 'write') {
            return (
                <div className="form-group">
                    {control.label &&
                        <label htmlFor={control.id}>
                            {control.label}
                            {control.require &&
                                <sup className="text-danger font-weight-bold">*</sup>
                            }
                            {control.showhelptext &&
                                <span className={"custom-tooltip"}>
                                    <i className={"fa fa-question-circle ml-2 help-text"}></i>
                                    <span className={"tooltip tooltip-" + control.helpdirection}>{control.help}</span>
                                </span>
                            }
                        </label>
                    }
                    {control.imageurl &&
                        <img width="100" height="100" alt={control.label} src={control.imageurl} className="mb-2 img-fluid" />
                    }
                    <div className={'form-control p-0' + (shouldMarkError ? " border-danger" : " border-0")} >
                        {/* {!control.enablecoreeditor ?
                            <ReactQuill style={{ "height": control.height }} value={data[control.key]}
                                onChange={(e) => this.handleChange(control, formid, e)} />
                            :
                            <TinyMCE value={data[control.key]}
                                content="<p>This is the initial content of the editor</p>"
                                config={{
                                    plugins: 'autolink link image lists print preview',
                                    toolbar: 'undo redo | bold italic | alignleft aligncenter alignright'
                                }}
                                onChange={(e) => this.handleChange(control, formid, e)}
                            />
                        } */}
                        <ReactQuill style={{ "height": control.height }} value={value ? value : ''} readOnly={control.editable == false || this.props.disabled ? true : false}
                            onChange={(e) => this.handleChange(control, formid, e)} onBlur={() => { this.handleBlur(); }}
                            theme="snow"
                        // modules={modules}
                        // formats={formats}
                        />
                    </div>
                    {shouldMarkError &&
                        <small className="form-text text-danger">
                            {control.errormsg ? control.errormsg : 'You must enter a ' + control.label + '.'}
                        </small>
                    }
                </div>
            );
        }
        else {
            return (
                <div>
                    <span>{control.label}</span>
                    <span>{this.props.editformdata[control.key]}</span>
                </div>
            );
        }
    }
}

export default connect(mapStateToProps, bindAction)(Editor);